// extracted by mini-css-extract-plugin
module.exports = {"navbar":"wrapper_navbar__KLC_p","scrolled":"wrapper_scrolled__GYT4_","blue-elements":"wrapper_blue-elements__gRPc0","navbar-to-blue":"wrapper_navbar-to-blue__lExmQ"};